<template>
    <div>
      <div v-if="debug_show_page_name==true" style="color:green;">page_0041_master_user</div>
        <app-header>esma</app-header>
        <div :class="'container ' + pageContainerSize">
          <title-and-search title="ユーザ一覧"></title-and-search>
          <search-control
          style="padding-bottom: 10px;"
          :field_names="allFields" @change="searchControlChangedDatasource"></search-control>
          <div>
            <input 
              @click="allChecked($event.target.value,$event.target)"
              style="float: right;"
              v-model="checkBoxSelectAll"
              :disabled="approveMode == 'reject'"
              type="checkbox" id="checkBoxSelectAll" name="checkBoxSelectAll" value="X">
          </div>
          <ag-grid-vue style="width: 100%; height: 325px" class="ag-blue" :gridOptions="gridOptions" ></ag-grid-vue>
          <br>
          <div style="float: left;;margin-top:5px">
            件数
            </div>
            <input type="text" data-cy="totalNumberOfRows" style="width: 5%;text-align: right;float: left;margin-left:5px" class="form-control limited-height-box" :disabled="true" :value="totalNumberOfRows" />
          <div style="margin-top:5px;">
            <button
            :disabled="formExportFileDisabled || checkUserPermission(true,permissionMode.EXPORT) == false"
            class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px" @click="initExportFile" >出力</button>
            <button
            :disabled="deleteBtnDisabled || checkUserPermission(true,permissionMode.DELETE) == false"
            class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #FF7C80;border-color:#FF7C80;" @click="onDelete">{{deleteText}}</button>
            <button
            :disabled="localBatchEditDisabled || disableIfCheckBoxNotSelected || checkUserPermission(true,permissionMode.EDIT) == false"
            class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;" @click="bachEdit" 
            >{{batchEditText}}</button>
            <button
            :disabled="checkUserPermission(true,permissionMode.ADD) == false"
             class="btn btn-primary" style="min-width:100px;width: 7%;float: right;margin-left: 10px;background: #92D050;border-color:#92D050;" @click="addNew" >新規</button>
             <span style="color:red;float: right;font-weight: 900;padding: 7px;">*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。</span>
          </div>
        </div>
        <confirmation-modal tag="deleteUsernModal" @done="onConfirmDelete" />
        <information-icon-modal tag = "showInformationIconModalMasterUser"/>
        <file-download-modal tag="runDeviceEmbeddedInformationDownloadModal" @close="onCloseExportFile"/>
    </div>
</template>

<script>
import Vue from 'vue';
import uuid from "uuid";
import { AgGridVue } from 'ag-grid-vue';
import { fields, filed_types } from '@/rules/fields_master_user';
import { utils } from '@/libs/utils';


import _debug from 'debug';
var mdebug = _debug('esma:master_user');
import acl from '@/rules/acl_rules';
import mixinPageCommon from '@/mixins/mixin_page_common';
import mixinDatasource from '@/mixins/mixin_datasource';
import { bus } from '@/libs/bus';

import fileDownloadModal from '@/components/modals/file-download-modal';

export default {
  mixins: [mixinPageCommon,mixinDatasource],
    components: {
    'ag-grid-vue': AgGridVue,
    'file-download-modal':fileDownloadModal
  },
  data() {
    return {
      api_name:"master_user",
      page_acl: acl.master_user,
      execute_filter_on_back:true,
      link_to_open:"#",
      select_all:false,
      local_batch_edit_disabled:false,
      red_error_msg:""
    };
  },
  computed: {
    redErrorMsg:{
      get(){
        return this.red_error_msg;
      },
      set(v){
        this.red_error_msg = v;
      }
    },
    localBatchEditDisabled:{
      get(){
        return this.local_batch_edit_disabled;
      },
      set(v){
        this.local_batch_edit_disabled = v;
      }
    },
    deleteBtnDisabled(){
      return this.formOutputQty == 0;
    },
    deleteText(){
      if(this.deleteBtnDisabled){
        return "削除";
      }else{
        return "削除 (" + this.formOutputQty + ")";
      }
    },
    checkBoxSelectAll:{
      get(){
        return this.select_all;
      },
      set(v){
        this.select_all = v;
      }
    },
    approveMode:{
      get(){
        return this.approve_mode;
      },
      set(v){
        this.approve_mode = v;
      }
    },
    linkToOpen:{
      get(){
        return this.link_to_open;
      },
      set(v){
        this.link_to_open = v;
      }
    },
    readOnly() {
      return this.read_only;
    },
    fieldList() {
      return fields;
    },
    typeList() {
      return filed_types;
    },
    allFields(){
      return this.tabFieldList;
    },
    values() {
      console.log('values');
      return this.data_values;
    },
    filterList() {
      return this.filter_list;
    },
    tabFieldList() {
      return [
        utils.extend(fields.status, {}),
        utils.extend(fields.user_id, {}),
        utils.extend(fields.user_shimei, {}),
        utils.extend(fields.role, {}),
        utils.extend(fields.company, {}),
        utils.extend(fields.department, {}),
        utils.extend(fields.team, {}),
      ];
    }
  },
  methods: {
    onArraySelected(obj){
    　var has_multiple = _.find(this.selectedRowArr,d=>{ 
        return d.has_multiple == true
      })
      var has_multiple = _.find(this.selectedRowArr,d=>{ return d.has_multiple == true })
      if(has_multiple){
        // console.log('TEST DEBUG 210522 (155 at page_0041_master_user.vue)[22:23]: HAS MULTIPLE', {  has_multiple});
       this.localBatchEditDisabled = true;
      }else{
        var group_company = _.groupBy(this.selectedRowArr,d=>{ return d.company +"/"+ d.department; })
        if(Object.keys(group_company).length > 1){
          // console.log('TEST DEBUG 210522 (164 at page_0041_master_user.vue)[22:24]: HAS DIF GROUP', { has_multiple });
    　 this.localBatchEditDisabled = true;
        }else{
          // console.log('TEST DEBUG 210522 (167 at page_0041_master_user.vue)[22:24]: RETURN FALSE', {  });
    　 this.localBatchEditDisabled = false;
          this.redErrorMsg = "";
        }
      }

      // console.log('TEST DEBUG 210522 (145 at page_0041_master_user.vue)[17:26]: ', {group_company,has_multiple, obj, selectedRowArr: this.selectedRowArr, result:this.localBatchEditDisabled});
    },
    allChecked(a,b){
      this.commonAllChecked("showInformationIconModalMasterUser")
    },
    hideCheckBox(data){
      return  false// (data && (data.approval_status == "申請中"))
    },
    onRowSelected(ev) {
      this.selected_row = ev.node.data.seq_id;
    },
    initExportFile(){
      //FILE_EXPORT_PART2 : Step 2
      bus.$emit("runDeviceEmbeddedInformationDownloadModal",{
        message: "ファイルを出力しています。",
        on_complete_message:"出力が完了しました。",
        title: "出力",
        filter: this.last_data_source_filter,
        sort: this.last_data_source_sort,
        url:"/master_user/export_data/"
      });
    },
    onCloseExportFile(){},
    bachEdit(){
      this.$notify({clean:true});
      var group_company = Object.keys(_.groupBy(this.selectedRowArr,d=>{ return d.company; }))
      if(group_company.length > 1){
        this.redErrorMsg = '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。';
        // this.$notify({
        //   title: '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。',
        //   type: 'error',
        //   duration: 10000
        // });
        return;
      }else{
        var has_multiple = _.find(this.selectedRowArr,d=>{ return d.has_multiple == true })
        if(has_multiple){
          this.redErrorMsg = '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。';
          // this.$notify({
          //   title: '*兼務設定がされているIDは一括編集不可のため、詳細から操作してください。',
          //   type: 'error',
          //   duration: 10000
          // });
          return;
        }
      }
      var p_id = uuid.v4()
      var obj = {company:group_company[0],arr:this.selectedRowArr.map(m=>{return m.seq_id})}
      this.$ajax.post('/master_user/check_user_in_charge_for_approval/', {obj}, (err, result) => {
        if(err ){
          this.$notify({
            title: 'Failed to check user data',
            text: err,
            type: 'error',
            duration: 10000
          });
        }else{
          if(result && result.found_user_in_charge_for_approval){
            this.$notify({
              title: 'このユーザーは申請中の申請ルートに含まれているため編集・一括編集できません',
              type: 'error',
              duration: 10000
            });
          }else{
            Vue.localStorage.set("bulk_edit_" + p_id, JSON.stringify(obj))
            return this.$router.push("/master_user/bulk_edit/" + p_id);
          }
        }
      })
    },
    onConfirmDelete(mode){
      if(mode == "yes"){
        if(Array.isArray(this.selectedRowArr) == false || this.selectedRowArr.length == 0){
          return;
        }
        var arr = this.selectedRowArr.map((m)=>{return m.seq_id;})
        var vm = this
        this.commonDeleteArr(vm,arr,()=>{
          // All Deleted
          vm.formOutputQty = 0;
          vm.selectedRowArr = [];
        });
      }
    },
    onDelete(){
      // return this.$router.push({ name: "page_0041_master_user_detail", params: {  seq_id:this.selected_row,cmd:"delete"} });
      bus.$emit("deleteUsernModal",{
        title: "削除",
        message: "ユーザ一の削除をしますがよろしいでしょうか?",
        yes_label: "削除",
        no_label: "キャンセル",
        yes_color:"danger",
        no_color:"info",
        model_height:"50"
      });
    },
    onEdit(){
      return this.$router.push({ name: "page_0041_master_user_detail", params: {  seq_id:this.selected_row,cmd:"edit"} });
    },
    addNew(){
      return this.$router.push({ name: "page_0041_master_user_detail", params: {  seq_id:"new"} });
    },
    onDetailsClick(ev, data) {
      console.log('onDetailsClick', data);
      return this.$router.push({ name: "page_0041_master_user_detail", params: {  seq_id:data.seq_id } });
    },
    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:true,show_checkbox:true,force_sort:{id:"department",direction:"asc"}})
    },
  },
  mounted() {
    window.sessionStorage.setItem('user_back_to_list', this.$route.fullPath)
    this.gridOptions.api.sizeColumnsToFit();
  },
  beforeDestroy() {
  },
  beforeMount() {
    this.$store.state[this.stateCurrentRow]= {};
    this.gridOptions = _.extend(this.commonGridOptions,{
      rowSelection:false
    }) ;
    this.initDatasource();
  }
};

</script>
<style scoped>
.esma_btn_form {
  margin: 2px 0px;
  width: 100%;
}
.esma_blue_input_box {
  border-color: #5b9bd5;
}
.esma_blue_input_div {
  margin-right: 2px;
}
input:focus::-webkit-input-placeholder {
  color: transparent;
}
</style>



// WEBPACK FOOTER //
// page_0041_master_user.vue?13a0e264